import { Box } from "@mui/material";
import styled from "styled-components";

export const LoadingContainer = styled(Box)<{ width: string }>`
  && {
    position: absolute;
    top: 50%;
    width: ${(props) => props.width};
    display: flex;
    justify-content: center;
    right: 0px;

    @media (max-width: 800px) {
      width: 100%;
    }
  }
`;
